import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import MUIDataTable from "mui-datatables";
import {BrowserRouter as Router , Switch, Route, Link, withRouter} from 'react-router-dom';
import {LiveHelp,TransferWithinAStation,SportsHandball,AccessibilityNew,SmsFailed,DirectionsRun,CheckCircle} from '@material-ui/icons/'
import Paper  from '@material-ui/core/Paper';

import ResidentDefaultF from './../../images/residents/resident_avatar_female.png'
import ResidentDefaultM from './../../images/residents/resident_avatar_male.png'

import Woman01 from './../../images/residents/woman_01.png'
import Woman02 from './../../images/residents/woman_02.png'
import Woman03 from './../../images/residents/woman_03.png'
import Woman04 from './../../images/residents/woman_04.png'
import Woman05 from './../../images/residents/woman_05.png'
import Woman06 from './../../images/residents/woman_06.png'
import Woman07 from './../../images/residents/woman_07.png'



// style the component
const useStyles = makeStyles({
  root: {
    margin: 'auto',
    padding: 10,
    '& a':{
        textDecoration: 'none',
        color: '#000',
    },
    '& tr:hover .AlertIconWrapper':{
        borderRadius:6,
        border:'1px solid',
    },
    '& tr:hover .AlertIconWrapper.icon_red':{
        color: '#f00',
        border:'1px solid #c00',
        backgroundColor: 'rgba(230,200,200, .3)',
    },
    '& tr:hover .AlertIconWrapper.icon_green':{
        color: '#090',
        border:'1px solid #4c6',
        backgroundColor: 'rgba(100,200,120, .3)',
    },
  },
  AlertIconWrapper:{
    padding: '2px 5px',
    border:'1px solid #ccc',
    borderRadius:6,
    
  },
  AlertIcon:{
    verticalAlign: 'middle',
    minWidth: 36,
    minHeight: 36,
    width: 36,
    height: 36,
    padding: 2,
    marginLeft: 8,
    marginRight: 10,
    '&.icon_red':{
        fill: '#c00',
    },
    '&.icon_green':{
        fill: '#4a6',
    },
  },
  AlertIconTitle:{
    fontWeight: 'bold',
    display: 'inline-block',
    margin: '0 3px',
    verticalAlign: 'middle',
    fontSize: '1.2em',
    '&.icon_red':{
        color: '#c00',
    },
    '&.icon_green':{
        color: '#4a6',
    },
  },
  ResidentPhoto:{
      maxWidth: 66,
      maxHeight: 66,
      display:'block',
      '& img':{
          width: '100%',
      }
  }
});

// provide table interface for active alerts
export default function ResidentsDatatable(props) {
  const classes = useStyles();
  const data = [
    [Woman01,"Meena","R100","Fall","Fall Risk","Assistance","F","1928-12-04","8581234567"],
    [Woman02,"Imogene","R101","Leave Room","Fall Risk","Assistance","F","1940-05-15","7609295555"],
    [Woman03,"Emily","R102","Call Help","Emergency","Assistance","F","1946-12-31","7602315162"],
    [Woman04,"Smrithi","R103","Standing Up","Fall Risk","Assistance","F","1950-01-01","9195732132"],
    [Woman05,"Gilda","R104","OK","-","Assistance","F","1950-12-12","7601052999"],
    [Woman06,"Janet","R105","OK","-","Assistance","F","1940-03-25","8581293600"],
    [Woman07,"Erika","R106","OK","-","Assistance","F","0000-00-00","7603442121"],
   ];
  
 // format name column data
 function ResidentPhoto(value){
     
    if (value == 'avatar.png'){
        let result =( <Link to='/residents/chart' className={classes.ResidentPhoto}> <img src={ResidentDefaultF}/> </Link> );
        return result
     }else{
        let result =( <Link to='/residents/chart' className={classes.ResidentPhoto}> <img src={value}/> </Link> );
        return result
     }
    
  }


   // format name column data
  function ResidentName(value){
    let result =( <Link to='/residents/chart' > <h3>{value}</h3> </Link> );
    return result
  }

  // provide dynamic icon for placement based on icon name
   function AlertIcon(icon){
    const icons = {
      'Leave Room': TransferWithinAStation,
      'Leave Building': DirectionsRun,
      'Call Help': SmsFailed,
      'Standing Up': AccessibilityNew,
      'Fall': SportsHandball,
      'OK': CheckCircle,
    };

    //let  DynamicIcon = icons[{icon}]
    let AlertIcon = icons[icon];
    let icon_color = 'icon_red'
    if (icon === 'OK'){
        icon_color = 'icon_green'
    }

    let result = ( 
        <React.Fragment>
            <Link to='/residents/chart'>
            <div className={classes.AlertIconWrapper + ' AlertIconWrapper ' +icon_color}>
                <AlertIcon className={classes.AlertIcon + ' '+icon_color}/>
                <span className={classes.AlertIconTitle +' ' +icon_color}>
                    {icon}
                </span>
            </div>
            </Link>
        </React.Fragment>
    )
    return result
  }
  
   // format name column data
   function ResidentRisks(value){
    let result =( <div> {value}</div> );
    return result
  }
   // format name column data
   function ResidentStatus(value){
    let result =( <div>{value}</div> );
    return result
  }
   // format name column data
   function ResidentGender(value){
    let result =( <div>{value}</div> );
    return result
  }
   // format name column data
   function ResidentDOB(value){
    let result =( <div>{value}</div> );
    return result
  }
   // format name column data
   function ResidentPhone(value){
    let result =( <div>{value}</div> );
    return result
  }

  // list of columns for datatable
  // Photo, Name, Room, Alert, Key Risk, Status, Actions
  /*
    {name: "Photo",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentPhoto(value))}},
    {name: "Name",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentName(value))}},
    "ID",
    {name: "Alert",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(AlertIcon(value))}},
    {name: "Key Risks",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentRisks(value))}},
    {name: "Status",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentStatus(value))}},
    {name: "Gender",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentGender(value))}},
    {name: "DOB",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentDOB(value))}},
    {name: "Phone",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentPhone(value))}},
  
  */

   const columns = [
    {name: "Photo",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentPhoto(value))}},
    {name: "Name",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentName(value))}},
    "ID",
    {name: "Alert",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(AlertIcon(value))}},
    {name: "Key Risks",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentRisks(value))}},
    {name: "Status",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentStatus(value))}},
    {name: "Gender",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentGender(value))}},
    {name: "DOB",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentDOB(value))}},
    {name: "Phone",options:{filter:true, customBodyRender:(value, tableMeta, updateValue)=>(ResidentPhone(value))}},
   ];

    // set options for datatable
   const options = {
   
  };


  // render the component
  return (
   <div className={classes.root}>

    <h2>Residents</h2>
    <Paper variant="outlined" className={classes.screenshot} >
    <MUIDataTable
    title={"Residents View"}
    data={data}
    columns={columns}
    options={options}
    /> 
    </Paper>
   </div>
  );
}





